/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnassignComplaintManagerCommand
 */
export interface UnassignComplaintManagerCommand {
    /**
     * 
     * @type {string}
     * @memberof UnassignComplaintManagerCommand
     */
    employeeId: string;
}

/**
 * Check if a given object implements the UnassignComplaintManagerCommand interface.
 */
export function instanceOfUnassignComplaintManagerCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "employeeId" in value;

    return isInstance;
}

export function UnassignComplaintManagerCommandFromJSON(json: any): UnassignComplaintManagerCommand {
    return UnassignComplaintManagerCommandFromJSONTyped(json, false);
}

export function UnassignComplaintManagerCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnassignComplaintManagerCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'],
    };
}

export function UnassignComplaintManagerCommandToJSON(value?: UnassignComplaintManagerCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'employeeId': value.employeeId,
    };
}

